module.exports = __webpack_public_path__ + "media/images/icons/question-icon-94203f479cecf9fc491a2769f4ac6270.svg";